<template>
    <div class="case__conten">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="title animate__animated animate__fadeInUp" style="margin-bottom: 50px"><span>{{title}}</span></div>
        <div class=" relative" style="background: #f1f1f1;">
            <div class="wite__bg"></div>
            <div class="wrapper__w">
                <el-row :gutter="30">
<!--              从低3个 开始 添加 wow-->
                    <el-col :span="(index % 5 == 0 || index % 5 == 1) ? 12 : 8" v-for="(item, index) in casesList" :key="index" class="mb30  animate__fadeInUp case_hover_box" :class="index > 4 ? 'wow' : 'animate__animated'"  data-wow-delay=".2s" data-wow-duration="0.8s">
                        <div @click="preeItem('/casedetail', {id: item.id})" style="cursor: pointer">
                            <div class="case__base--img hover_box_img"><img :src="item.cover" style="height: 386px"></div>
                            <div class="case__base">
                                <el-row :gutter="0">
                                    <el-col :span="12"><div class="title textover"><span>{{item.name}}</span></div></el-col>
                                    <el-col :span="12" style="text-align: right" v-if="item.can_order == 1"><div class="pro__button footFm-but transition"  @click.stop="submitShow(item.id)" >预约参观</div></el-col>
                                </el-row>
                                <div class="des">{{item.address}}</div>
                                <div class="city">
                                    <i>城市：{{item.city}}</i>
                                    <i>面积：{{item.area}}<span class="pf">㎡</span></i>
                                    <i>年份：{{item.year}}</i>
                                </div>
                            </div>
                        </div>
                    </el-col>

                </el-row>
            </div>
            <div class="look__mores" @click="lookMore()"><span>查看更多</span></div>
        </div>
        <Footer></Footer>

        <el-dialog title="预约参观项目" width="30%" center :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="您的姓名：" label-width="120px">
                    <el-input v-model="form.name"  clearable></el-input>
                </el-form-item>
                <el-form-item label="您的手机：" label-width="120px">
                    <el-input v-model="form.mobile" clearable></el-input>
                </el-form-item>
                <el-form-item label="所在城市：" label-width="120px">
                    <el-input v-model="form.city" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitFun()" :loading="isSubmit">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
    import icon_stra from '@/assets/img/case1.png'
    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'
    import { isPhone } from '@/libs/common'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,
                id: '',
                pagesize: 7,
                casesList: [],

                dialogFormVisible: false,
                form: {
                    name: '',
                    mobile: '',
                    city: ''
                },
                isSubmit: false,
                case_id: '',
                title: '全部案例',
            }
        },
        components: {
            NavSecond,Footer
        },
        watch: {
            '$route' (to, form) {
                this.pagesize = 7
                this.init()
            }
        },
        methods: {
            /**
             * @description点击跳转
             * */
            preeItem (path, query){
                this.$router.push({path, query})
            },
            /**
             * @description详情
             * */
            getList (){
                this.$xhr(this.$api.casesList, {id: this.id,pagesize:this.pagesize,pagenum:1}).then(res => {
                    this.casesList = res.list
                })
            },
            lookMore (){
                this.pagesize+=7
                this.getList()
            },
            submitShow (case_id){
                this.case_id = case_id
                this.dialogFormVisible = true
            },
            /**
             * @description预约
             * */
            submitFun (){
                const {city, name, mobile} = this.form
                if(!name){
                    this.$message.error('请输入称呼')
                    return false
                }
                if(!city){
                    this.$message.error('请输入城市')
                    return false
                }
                if(!mobile){
                    this.$message.error('请输入联系电话')
                    return false
                }
                if (!isPhone(mobile)){
                    this.$message.error('请输入正确的手机号')
                    return false
                }
                this.isSubmit = true
                this.$xhr(this.$api.casesNote, Object.assign(this.form, {case_id: this.id})).then(res => {
                    this.dialogFormVisible = false
                    this.isSubmit = false
                    this.$message({
                        message: '预约成功，稍后会有工作人员联系您，请耐心等待',
                        type: 'success',
                        duration: '3000'
                    });
                })
            },
            init (){
                const {type, name} = this.$route.query
                this.id = type ? type : 0
                this.title = name ? name : '全部案例'
                this.getList()
            }
        },
        mounted() {
            this.$wow.init()
            this.$nextTick(() => {
                this.init()
            })
        }
    }
</script>
<style  lang="scss" scoped>
    .case__conten{
        .look__mores{
            text-align: center;
            padding: 80px 0;
            cursor: pointer;
            span{
                display: inline-block;
                margin: 0 auto;
                height: 58px;
                line-height: 58px;
                border: 1px solid #808080;
                font-size: 22px;
                font-weight: 400;
                color: #808080;
                padding: 0 75px;
            }
        }
        .wite__bg{
            background: #fff;
            height: 380px;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
        }
        .title{
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            height: 200px;
            line-height: 250px;
            span{
                position: relative;
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -20px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }

        }
        .case__base--img{
            img{
                width: 100%;
                display: block;
                object-fit: cover;
            }
        }
        .pro__button{
            cursor: pointer;
            display: inline-block;
            width: 106px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            border: 1px solid #F15315;
            font-size: 16px;
            font-weight: 400;
            color: #F15315;
        }
        .case__base{
            padding: 5%;
            background: #fff;
            .title{
                height: auto;
                line-height: unset;
                text-align: left;
                font-size: 28px;
                span::after{
                        content: '';
                        display: block;
                        position: absolute;
                        left: 0;
                        margin-left: 0;
                        bottom: -10px;
                        width: 32px;
                        height: 2px;
                        background: #F55E1B;
                }
            }
            .des{
                font-size: 20px;
                font-weight: 400;
                color: #000000;
                margin-top: 23px;
            }
            .city{
                font-size: 16px;
                font-weight: 400;
                color: #7F7F7F;
                margin-top: 10px;
                i{
                    margin-right: 20px;
                    font-style: normal;
                }
            }
        }
    }
    .pf{
        /*font-weight: 500;*/
    }

</style>
